import {
  INSTANCE_FATD_OPTIONS_READ_META,
} from 'client/redux/fatd/constants';
import { instanceFatdReadMeta } from 'client/redux/fatd/actionCreators';

export const instanceFatdOptionsReadMeta = instanceId => dispatch => dispatch(instanceFatdReadMeta(INSTANCE_FATD_OPTIONS_READ_META, instanceId));

